var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"production-control-wrapper"},[(_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('SpeenComponent',{attrs:{"isAutomatic":true,"ringWidth":14,"spinnerSize":15,"isverticalAligned":true}})],1):_c('div',[_c('ControlProduccionHeader'),_vm._v(" "),_c('Kanban'),_vm._v(" "),_c('MultiModal')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }